import { render, staticRenderFns } from "./animal-registration-picker.vue?vue&type=template&id=053e9398&"
import script from "./animal-registration-picker.vue?vue&type=script&lang=js&"
export * from "./animal-registration-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports